export default "__VITE_ASSET__0Vx7OltF__"